<template>
  <!-- 详细信息弹窗 -->
  <div class="billPh">
    <van-popup
      v-model="showModel"
      round
      :close-on-click-overlay="false"
      :get-container="getContainer"
    >
      <!-- <div class="showD" v-if="showModel"> -->
      <div class="wrap">
        <div class="content">
          <!-- <div class="circle"></div> -->
          <div class="ti">
            <img class="tiLogo" src="../../assets/img/zfnotice.png" alt="" />
            <!-- 支付提醒 -->
            <!-- <div class="close" @click="closeDialog">×</div> -->
          </div>
          <div style="padding: 0 20px" class="cBox">
            <div class="cont" v-if="curData" v-html="curData.promptContent"></div>
          </div>

          <div class="butarea">
            <!-- <div class="rbutton cancel">取消支付</div> -->
            <van-button
              @click="confirmPay"
              block
              class="confirm"
              round
              type="info"
              >继续支付
              <img class="blueSha" src="../../assets/img/blueshadow.png" alt="" /></van-button
            >
            <div @click="closeDialog" class="cancel">取消支付</div>
          </div>
          <!-- </div> -->
        </div>
      </div>
    </van-popup>

    <!-- <van-dialog v-model="showModel" title="温馨提示"
      :before-close='closePay'
      show-cancel-button
      confirm-button-text='确认支付'
      cancel-button-text='关闭'>
       <p  v-if='isShowPhone' class="notice">*填写手机号码后，可用该手机号码查询电子发票。</p>
        <van-form ref="formPhone">
            <van-field v-if='isShowPhone'
                v-model="phone"
                type="text"
                label="手机号码"
                :rules="[{ validator, message: '请输入正确格式手机号' }]"
                placeholder="请输入手机号"
            />
            <van-field v-if='isBill' readonly
                v-model="payerTypeName"
                @click="showType=true"
                label="缴款人类型"
                placeholder="请选择缴款人类型"
            />
            </van-form>
    </van-dialog> -->
  </div>
</template>

<script>
import { Notify } from "vant";
export default {
  props: ["payInfo", "isShowDetail"],
  data() {
    return {
      showModel: false,
      detailData: [],
      dictionaryObj: {},
      showField: false,
      fieldList: [],
      detailList: [],
      notFileNum: 0,
      curData: null,
    };
  },
  watch: {
    isShowDetail: {
      deep: true,
      handler(newV, oldV) {
        if (newV) {
          this.handleInfo();
          this.showModel = true;
        }
      },
    },
    payInfo: {
      handler(newV) {
        if (newV) {
          this.curData = newV;
        }
      },
      deep: true,
    },
  },
  methods: {
    getContainer() {
      return document.querySelector(".billPh");
    },
    handleInfo() {},
    closeDialog() {
      this.showModel = false;
      this.$emit("closeDialog");
    },
    confirmPay() {
      this.showModel = false;
      this.$emit("payContinue");
    },
    getUrl(id) {
      this.request({
        url: "/business/showFile",
        method: "post",
        params: {
          dataId: id,
        },
      }).then((res) => {
        if (res.data.code == 1000) {
          this.fieldList = res.data.result;
          if (this.fieldList.length == 1) {
            window.location.href = this.fieldList[0].fileUrl;
          } else {
            this.showField = true;
          }
        } else {
          Notify({ type: "danger", message: res.data.message });
        }
      });
    },
    openUrl(url) {
      window.open(url);
    },
  },
};
</script>
<style lang='scss' scoped>
.billPh {
  ::v-deep .van-popup {
    background-color: transparent;
  }
}
.phoneBox {
  position: relative;
  border-bottom: 1px solid #eee;

  font-size: 14px;
  color: #464a4c;
  letter-spacing: 0;
  font-weight: 400;
  > img {
    width: 14px;
    position: absolute;
    top: 16px;
    right: 10px;
  }
}
.billBox {
  position: relative;
  border-bottom: 1px solid #eee;

  font-size: 14px;
  color: #464a4c;
  letter-spacing: 0;
  font-weight: 400;
  > img {
    width: 14px;
    position: absolute;
    top: 16px;
    right: 10px;
  }
  ::v-deep .van-field__right-icon {
    color: rgba(0, 0, 0, 0.3);
  }
}
.cBox {
  margin-top: 20px;
  ::v-deep .van-cell {
    padding: 0.26667rem 0px;
  }
  ::v-deep .van-field__control {
    max-width: 100%;
  }
}
.notice {
  line-height: 14px;
  // padding: 0.1rem 0;
  width: 304px;
  height: 44px;
  margin: 0 auto;
  background: #f1f1f1;
  border-radius: 10px;

  font-size: 14px;
  color: #f46c6c;
  letter-spacing: 0;
  font-weight: 400;
  text-align: center;
  box-sizing: border-box;
}
.cont {
  font-size: 14px;
  max-height: 186px;
  overflow-y: auto;
  padding: 10px 0px;
  padding-top: 0px;
  line-height: 24px;
  // padding-top: 20px;
  word-break: break-all;
  // border-bottom: 1px dashed #dedede;

  font-size: 14px;
  color: #464a4c;
  letter-spacing: 0;
  font-weight: 400;
}
.ti {
  position: relative;
  // text-align: center;
  // position: absolute;
  // top: 4%;
  // left: 50%;
  // z-index: 1001;
  // width: 86%;
  // transform: translateX(-50%);
  font-size: 16px;
  // color: #fff;
  padding: 18px 0px;
  border-radius: 8px 8px 0px 0px;
  // background: url("../assets/img/zfnotice.png");
  // background-size: cover;
  ::v-deep .van-divider {
    margin: 10px 0px !important;
    background: rgb(235, 235, 235) !important;
  }
  .tiLogo {
    position: absolute;
    width: 310px;
    height: 90px;
    left: 50%;
    top: -132%;
    transform: translateX(-50%);
    z-index: 9999;
  }
}
.deta {
  display: flex;
  justify-content: space-between;
}
.showD {
  // position: fixed;
  // z-index: 1000;
  // height: 100vh;
  // width: 100vw;
  // background: rgba(0, 0, 0, 0.5);
  // top: 0%;
  // left: 50%;
  // transform: translateX(-50%);
}
.close {
  position: absolute;
  right: 20px;
  bottom: 18px;
  font-size: 24px;
  color: #fff;
}
.circle {
  width: 80px;
  height: 80px;
  background: #fff;
  position: absolute;
  top: 0;
  left: 50%;
  transform: translate(-50%, -30%);
  border-radius: 50%;
  z-index: -1;
}
.dialogTitle {
  .van-dialog__header {
    background: #1989fa;
    color: #fff;
    padding: 10px 0 !important;
    font-weight: 600 !important;
  }
}
.content {
  width: 344px;
  // border-radius: 8px;
  // position: absolute;
  // top: 50%;
  // left: 50%;
  // width: 72%;
  // max-height: 75%;
  // transform: translate(-50%, -50%);
  // background: #fff;
  // text-align: left;
  // line-height: 24px;
  // ::v-deep .van-divider {
  //   background: rgb(235, 235, 235) !important;
  // }
  background: #fff;
  border-radius: 0.42667rem;
}

.butarea {
  // display: flex;
  padding: 20px 6px;
  padding-bottom: 10px;
  text-align: center;
  // justify-content: space-around;
  .cancel {
    width: 305px;
    height: 44px;
    color: #777 !important;
    margin: 0 auto;

    font-size: 15px;
    color: #888888;
    letter-spacing: 0;
    font-weight: 400;
    margin-top: 24px;
  }
  .confirm {
    width: 305px;
    height: 44px;
    color: #fff !important;
    background-image: linear-gradient(-45deg, #54adfb 0%, #297bf4 100%);
    border-radius: 22px;
    margin: 0 auto;

    font-size: 18px;
    color: #ffffff;
    letter-spacing: 0;
    font-weight: 700;
    position: relative;
    .blueSha{
      width: 286px;
      height: 34px;
      position: absolute;
      left: 50%;
      top: 68%;
      transform: translateX(-50%);
    }
  }
}

.van-popup {
}
.wrap {
  padding-top: 50px;
}
</style>
